import verificationConstants    from './verification.constants';
import verificationInitialState from './verification.state';

export function verificationReducer(state = verificationInitialState, action) {
  switch (action.type) {
    case verificationConstants.VERIFICATION_GET_DATA_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case verificationConstants.VERIFICATION_GET_DATA_SUCCESS:
      state = {
        ...state,
        order:   { ...action.data },
        loading: false,
      };
      break;

    case verificationConstants.VERIFICATION_GET_DATA_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default verificationReducer;